<template>
  <div>
    <v-row v-for="(smartBet, i) in smartBets" :key="i" justify="center">
      <image-card
        classes="border--golden"
        class="card-rounded mb-2"
        width="280"
        aspect-ratio="1.4"
        :src="smartBet.image"
        :lazy-src="smartBet.image"
        alt="football tutorials"
      />
    </v-row>
  </div>
</template>

<script>
import ImageCard from '@/components/fairplay/ImageCard'

export default {
  name: 'ItemSlider',
  components: { ImageCard },
  data: () => ({
    // smartBets: [
    //   {
    //     image: require('@/assets/images/tutorial.png')
    //   },
    //   {
    //     image: require('@/assets/images/tutorial.png')
    //   },
    //   {
    //     image: require('@/assets/images/tutorial.png')
    //   },
    //   {
    //     image: require('@/assets/images/tutorial.png')
    //   },
    //   {
    //     image: require('@/assets/images/tutorial.png')
    //   },
    //   {
    //     image: require('@/assets/images/tutorial.png')
    //   }
    // ]
  })
}
</script>
